import { Customer } from '../../types/customer';

export const SET_CUSTOMERS = 'SET_CUSTOMERS';

export class SetCustomers {
  readonly type = SET_CUSTOMERS;
  readonly payload: Customer[];

  constructor(types: Customer[]) {
    this.payload = types;
  }
}

export type Action = SetCustomers;
